// src/PermissionGrid.js - FIXED DATA GRID ERROR
import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import api from './apiClient';
import { useSnackbar } from 'notistack';

function PermissionGrid({ workspaceId, users }) {
  const { enqueueSnackbar } = useSnackbar();
  const [roles, setRoles] = useState([]);
  const [customRoles, setCustomRoles] = useState([]);

  useEffect(() => {
    if (workspaceId) {
      api.get('/api/workspace-permissions', { params: { workspace_id: workspaceId } }).then(res => setRoles(res.data));
    }
  }, [workspaceId]);

  const columns = [
    { field: 'username', headerName: 'User', width: 200 },
    {
      field: 'role',
      headerName: 'Role',
      width: 150,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['viewer', 'editor', 'admin', ...customRoles.map(cr => ({ value: cr.id, label: cr.name }))],
    },
  ];
  useEffect(() => {
    if (workspaceId) {
      api.get('/api/workspace-permissions', { params: { workspace_id: workspaceId } })
        .then(res => setRoles(res.data))
        .catch(err => enqueueSnackbar('Error loading roles', { variant: 'error' }));
    }
  }, [workspaceId]);

  useEffect(() => {
    if (workspaceId) {
      api.get('/api/custom-roles', { params: { workspace_id: workspaceId } })
        .then(res => setCustomRoles(res.data))
        .catch(err => enqueueSnackbar('Error loading custom roles', { variant: 'error' }));
    }
  }, [workspaceId]);

  const handleEditCommit = async (params) => {
    try {
      await api.put(`/api/roles/${params.row.user_id}`, { workspace_id: workspaceId, role: params.value, user_id: params.row.user_id }); // Use PUT for update
      enqueueSnackbar('Role updated', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('Error updating role', { variant: 'error' });
    }
  };

  return (
    <DataGrid
      rows={roles}
      columns={columns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      onCellEditCommit={handleEditCommit}
      autoHeight
      getRowId={(row) => row.user_id} // FIXED: Use user_id as unique id
    />
  );
}

export default PermissionGrid;
